import Auth from './auth_core.js'

function plugin(app, options) {
  const auth = new Auth(options)

  app.config.globalProperties.$auth = auth

  app.provide('auth', auth)
}

export default plugin
